import React, { createContext, useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useContextProperties } from 'contexts/properties';
import { useContextCurrentSite } from 'contexts/currentSite';
import { TYPES } from 'envs';

const MatchParamsContext = createContext();

export const MatchParamsProvider = ({ matchParamsProps, children }) => {
  const { params } = useContextProperties();
  const { currentSite } = useContextCurrentSite();

  const {
    country,
    community,
    allMap,
    navigableMode,
    year,
    type,
    subtype,
    electionNumber,
    chartType,
    showMasterBar,
    changeOrder
  } = params.elections.defaultParams;

  const initialParams = {
    site: currentSite,
    country,
    community,
    allMap,
    navigableMode,
    year,
    type,
    subtype,
    electionNumber,
    chartType,
    showMasterBar,
    changeOrder
  };

  const [matchParams, setMatchParams] = useState();

  const setParams = newParams => {
    let nPCommunity = newParams.community;
    let newElectionNumber = '1';
    let newSubtype = 'SINGLE';
    let newAllMap = newParams.allMap;

    if (newParams.type === TYPES.GENERAL) {
      if (!newParams.community) {
        nPCommunity = 'C108';
      }
      if (newParams.year === '2019') {
        newElectionNumber = '2';
      }
      newAllMap = nPCommunity === 'C108' ? 1 : 0;
      newSubtype =
        newParams.subtype === 'SINGLE' ? 'CONGRESS' : newParams.subtype;
    }

    const nP = {
      ...newParams,
      subtype: newSubtype,
      community: nPCommunity,
      electionNumber: newElectionNumber,
      allMap: newAllMap
    };

    setMatchParams(nP);
  };

  useEffect(() => {
    if (Object.keys(matchParamsProps).length > 0) {
      setMatchParams(matchParamsProps);
    } else {
      setMatchParams(initialParams);
    }
  }, [matchParamsProps]);

  if (!matchParams) {
    return null;
  }
  return (
    <MatchParamsContext.Provider value={{ matchParams, setParams }}>
      {children}
    </MatchParamsContext.Provider>
  );
};

export const useContextMatchParams = () => useContext(MatchParamsContext);

MatchParamsProvider.propTypes = {
  matchParamsProps: PropTypes.shape({
    site: PropTypes.string,
    country: PropTypes.string,
    community: PropTypes.string,
    allMap: PropTypes.string,
    navigableMode: PropTypes.string,
    year: PropTypes.string,
    type: PropTypes.string,
    subtype: PropTypes.string,
    electionNumber: PropTypes.string,
    chartType: PropTypes.string,
    showMasterBar: PropTypes.string,
    chageOrder: PropTypes.string
  }),
  children: PropTypes.node.isRequired
};
MatchParamsProvider.defaultProps = {
  matchParamsProps: {}
};
